var _circle, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _rect3, _path17, _rect4, _circle2, _path18, _path19, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 87.5,
    fill: "#E9E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5541 37.2101L84.5656 37.2768L82.1701 37.5236C75.9926 38.1607 71.709 43.9832 72.9399 50.0699L73.4991 52.8373C73.8595 54.6184 75.5228 55.8291 77.3273 55.6266L111.291 51.8193C113.343 51.5894 114.753 49.6469 114.335 47.6262L113.545 43.7966C112.452 38.5095 107.534 34.908 102.164 35.4618L99.7023 35.7155L99.5207 34.5775C98.8721 30.566 95.1852 27.7731 91.1467 28.239C86.7593 28.7452 83.7267 32.8717 84.5541 37.2101ZM94.8682 35.66C95.1103 35.1858 95.2343 34.6312 95.2025 34.0457C95.1132 32.4127 93.8419 31.1555 92.3631 31.2373C90.8872 31.3191 89.7601 32.7089 89.8524 34.3419C89.9417 35.9745 91.213 37.2321 92.6918 37.1503C93.6373 37.0977 94.4386 36.5075 94.8682 35.66Z",
    fill: "#DC466D",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0871 55.651C46.742 54.0275 47.1114 52.4889 47.985 51.3245C48.0905 51.1839 48.2034 51.0487 48.3233 50.9195L52.2922 47.6124L53.2966 49.0947L130.03 41.0297C133.273 40.6889 136.451 42.998 137.129 46.1872L158.661 147.488C158.722 147.775 158.761 148.059 158.778 148.339L159.717 148.116L157.648 151.962C156.804 153.005 155.539 153.72 154.017 153.879L75.7179 162.109C72.4753 162.45 69.2971 160.141 68.6192 156.951L47.0871 55.651Z",
    fill: "#44179B",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90.538,
    height: 115.371,
    rx: 7.85024,
    transform: "matrix(0.994522 -0.104528 0.207912 0.978148 48.6562 46.5283)",
    fill: "url(#paint0_linear_186_23802)",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.978 44.4643L59.0423 52.025C56.8864 52.2516 55.504 54.1542 55.9548 56.2747L65.7625 102.417C68.851 116.904 73.3154 133.548 86.9381 132.371L147.71 124.09C149.799 123.806 151.112 121.94 150.682 119.871L135.701 47.9095C135.258 45.7819 133.14 44.237 130.978 44.4643Z",
    fill: "url(#paint1_linear_186_23802)",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7227 98.2287L122.94 95.176",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7949 104.693L136.223 100.384",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0648 132.18C87.397 132.275 86.7094 132.351 86.002 132.41L88.0648 132.18C103.09 130.061 108.139 119.049 106.191 105.339C105.862 103.019 107.407 100.777 109.732 100.498L170.482 93.198C172.258 92.9845 173.977 93.9926 174.382 95.7352C176.516 104.909 174.953 121.366 155.544 124.676L88.0648 132.18Z",
    fill: "url(#paint2_linear_186_23802)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.002 132.41C102.627 131.034 108.226 119.659 106.191 105.339C105.862 103.019 107.407 100.777 109.732 100.498L170.482 93.198C172.258 92.9845 173.977 93.9926 174.382 95.7352C176.516 104.909 174.953 121.366 155.544 124.676L86.002 132.41Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1056 72.7648L68.5353 70.1433C68.0943 68.1163 69.5119 66.1556 71.575 65.939L76.1423 65.4596C77.9458 65.2702 79.5928 66.4965 79.9286 68.2786L80.4219 70.8967C80.7981 72.8937 79.3919 74.7873 77.3715 75.0046L72.8813 75.4874C71.112 75.6776 69.4839 74.5036 69.1056 72.7648Z",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6544 89.579L72.0841 86.9575C71.6432 84.9305 73.0608 82.9698 75.1238 82.7532L79.6911 82.2738C81.4946 82.0845 83.1417 83.3107 83.4774 85.0928L83.9707 87.7109C84.3469 89.7079 82.9408 91.6015 80.9203 91.8188L76.4301 92.3016C74.6608 92.4918 73.0327 91.3178 72.6544 89.579Z",
    stroke: "#BEB1FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1993 106.393L75.6291 103.771C75.1881 101.744 76.6057 99.7837 78.6688 99.5672L83.236 99.0877C85.0395 98.8984 86.6866 100.125 87.0223 101.907L87.5156 104.525C87.8918 106.522 86.4857 108.415 84.4652 108.633L79.975 109.116C78.2058 109.306 76.5776 108.132 76.1993 106.393Z",
    stroke: "#BEB1FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0469 65.1511L117.264 62.0984",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.127 71.6157L130.555 67.3062",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5684 81.6902L119.786 78.6375",
    stroke: "#BEB1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6504 88.1535L133.079 83.844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5404 36.0272L87.5519 36.0939L85.1565 36.3407C78.979 36.9778 74.6953 42.8004 75.9262 48.8871L76.4855 51.6544C76.8458 53.4355 78.5091 54.6462 80.3136 54.4437L114.277 50.6365C116.329 50.4066 117.739 48.464 117.321 46.4433L116.531 42.6137C115.439 37.3266 110.521 33.7251 105.15 34.2789L102.689 34.5326L102.507 33.3947C101.858 29.3831 98.1716 26.5902 94.133 27.0561C89.7456 27.5624 86.7131 31.6889 87.5404 36.0272ZM97.8545 34.4771C98.0966 34.0029 98.2206 33.4484 98.1889 32.8628C98.0995 31.2298 96.8283 29.9726 95.3495 30.0544C93.8736 30.1362 92.7464 31.526 92.8387 33.159C92.9281 34.7917 94.1993 36.0492 95.6781 35.9674C96.6236 35.9148 97.425 35.3246 97.8545 34.4771Z",
    fill: "#F56087",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8293 109.179C80.5432 121.014 64.2315 123.892 52.396 115.605C40.5606 107.319 37.6832 91.0076 45.9693 79.1722C54.2554 67.3367 70.5672 64.4594 82.4027 72.7455C94.2381 81.0316 97.1154 97.3434 88.8293 109.179ZM84.3684 106.055C77.8072 115.427 64.8911 117.705 55.5194 111.144C46.1477 104.583 43.8694 91.6669 50.4306 82.2952C56.9917 72.9236 69.9079 70.6452 79.2795 77.2064C88.6512 83.7676 90.9296 96.6837 84.3684 106.055Z",
    fill: "#8963FE",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.9455,
    height: 6.03071,
    transform: "matrix(-0.573522 0.81919 0.81919 0.573522 53.1582 111.117)",
    fill: "#BDB0FF",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28.6556,
    height: 8.73884,
    rx: 4.36942,
    transform: "matrix(-0.573522 0.81919 0.81919 0.573522 45.5508 119.621)",
    fill: "#B936D3",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2161 123.213C51.2303 124.674 51.2851 126.67 50.2057 128.212L38.783 144.528C37.399 146.505 34.6745 146.985 32.6977 145.601C31.2882 144.614 30.6393 142.946 30.8847 141.353C31.1709 141.765 31.5335 142.135 31.9686 142.439C33.9454 143.824 36.6699 143.343 38.0539 141.366L49.4766 125.05C49.8738 124.483 50.1174 123.854 50.2161 123.213Z",
    fill: "#A924C3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 28.6556,
    height: 8.73884,
    rx: 4.36942,
    transform: "matrix(-0.573522 0.81919 0.81919 0.573522 45.5508 119.621)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7143,
    cy: 20.7143,
    r: 20.7143,
    transform: "matrix(-0.573522 0.81919 0.81919 0.573522 60.0156 63.0315)",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7588 97.2043C60.8814 96.7111 60.57 95.6001 61.0631 94.7228C61.5191 93.9116 62.0293 93.294 62.5938 92.87C63.1935 92.4361 63.8052 92.1128 64.4289 91.9C65.0878 91.6773 65.7376 91.5236 66.3782 91.4389C67.0315 91.3317 67.6447 91.2168 68.2177 91.0941C68.826 90.9616 69.3744 90.7509 69.8629 90.4621C70.3739 90.1859 70.7814 89.7775 71.0854 89.2367C71.2247 88.9888 71.3492 88.6882 71.4589 88.3347C71.5687 87.9813 71.5932 87.5947 71.5325 87.1752C71.507 86.7457 71.3309 86.3205 71.0041 85.8996C70.69 85.4562 70.1836 85.0381 69.4851 84.6455C68.719 84.2149 68.036 83.9793 67.4362 83.9386C66.8589 83.9106 66.3449 84.0072 65.8944 84.2284C65.4791 84.4398 65.1187 84.7116 64.8133 85.044C64.0113 86.0222 62.7309 86.4977 61.6282 85.8779L61.3096 85.6988C60.0309 84.9801 59.5404 83.3377 60.3385 82.107C60.6297 81.658 60.9122 81.27 61.1349 81.0639C61.7754 80.5047 62.4793 80.0701 63.2466 79.7601C64.0491 79.4402 64.9136 79.2738 65.8401 79.2608C66.7793 79.2253 67.7628 79.3482 68.7908 79.6295C69.8188 79.9108 70.8848 80.3618 71.9889 80.9824C72.9353 81.5143 73.7634 82.0984 74.4733 82.7346C75.2183 83.361 75.805 84.0318 76.2332 84.7469C76.6967 85.4522 77.0145 86.1794 77.1865 86.9284C77.3585 87.6774 77.3848 88.4483 77.2653 89.2411C77.1459 90.0339 76.8645 90.8246 76.4212 91.6132C75.864 92.6047 75.2425 93.3673 74.557 93.9012C73.8841 94.4125 73.1654 94.7943 72.4009 95.0466C71.6716 95.289 70.9402 95.4561 70.2066 95.5479C69.473 95.6396 68.762 95.744 68.0735 95.8611C67.4202 95.9683 66.8267 96.1537 66.2932 96.4172C66.1737 96.4762 66.0314 96.593 65.8786 96.7456C64.9241 97.699 63.4756 98.1693 62.2996 97.5082L61.7588 97.2043ZM58.3901 104.384C57.0834 103.65 56.6196 101.995 57.3541 100.688C58.0885 99.3818 59.7432 98.9179 61.0499 99.6524L61.1175 99.6904C62.4241 100.425 62.888 102.08 62.1535 103.386C61.4191 104.693 59.7644 105.157 58.4577 104.422L58.3901 104.384Z",
    fill: "#F56087",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5344 106.884C78.2483 118.719 61.9366 121.597 50.1011 113.311C38.2656 105.024 35.3883 88.7127 43.6744 76.8773C51.9605 65.0418 68.2723 62.1645 80.1077 70.4506C91.9432 78.7367 94.8205 95.0484 86.5344 106.884ZM82.0735 103.76C75.5123 113.132 62.5961 115.41 53.2245 108.849C43.8528 102.288 41.5745 89.372 48.1356 80.0003C54.6968 70.6286 67.613 68.3503 76.9846 74.9115C86.3563 81.4727 88.6346 94.3888 82.0735 103.76Z",
    fill: "#BDB0FF",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9306,
    cy: 64.31,
    r: 2.28019,
    fill: "#611FE2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.593,
    cy: 137.207,
    r: 2.28019,
    fill: "#611FE2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.433,
    cy: 81.9464,
    r: 2.28019,
    fill: "#611FE2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6472,
    cy: 52.4737,
    r: 4.15896,
    fill: "#611FE2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.29,
    cy: 73.4305,
    r: 4.15896,
    fill: "#611FE2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7019,
    cy: 160.502,
    r: 4.15896,
    fill: "#611FE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_23802",
    x1: 45.269,
    y1: 0,
    x2: 45.269,
    y2: 115.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875FFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_186_23802",
    x1: 95.0184,
    y1: 48.2438,
    x2: 103.676,
    y2: 130.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_186_23802",
    x1: 142.173,
    y1: 95.8059,
    x2: 136.056,
    y2: 127.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D85FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceEmpty);
export default __webpack_public_path__ + "static/media/performance-empty.17c64c9b4f506b14ffbba75e55507a7a.svg";
export { ForwardRef as ReactComponent };